import React from 'react';
import Marketing from '../images/marketing.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Meta Ad Campaigns',
    description: 'Drive targeted traffic with Meta ad campaigns. Our strategies include creating and managing ads on platforms like Facebook and Instagram to generate quality leads.',
  },
  {
    icon: <FaLock />,
    title: 'Google Ads',
    description: 'Increase visibility and attract potential customers with Google Ads. We manage PPC campaigns to drive targeted traffic and improve conversion rates.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Ads Manager Control & Assessments',
    description: 'Optimize ad performance with Ads Manager control and assessments. We monitor and adjust campaigns to ensure maximum efficiency and return on investment.',
  },
  {
    icon: <FaDesktop />,
    title: 'Analytics Monitoring & Reporting',
    description: 'Track your ad performance with detailed analytics. We provide reports and insights to help you understand the effectiveness of your campaigns and make data-driven decisions',
  },
];

const LeadGeneration = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Marketing}
        alt="Marketing Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Lead Generation</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
        <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Marketing Services</h2>
        <p className="text-md text-black mb-6 px-12 text-left">
        Maximize efficiency, enhance security, and drive growth with our tailored Marketing Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Marketing planning to meet your business needs.
        </p>
        
        <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
        </div>
      </section>

    </div>

    </div>
  )
}

export default LeadGeneration
